import axios from 'axios'
import Utils from '../services/Utils'
import moment from 'moment'

axios.defaults.timeout = 600000
axios.defaults.urls = JSON.parse(process.env.VUE_APP_URL)
axios.defaults.ptApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].base
axios.defaults.storageApiUrl = axios.defaults.urls[window.apiDev ? 'dev' : 'prod'][window.apiKey].storage


export default {
    getAuthorization: function () {
        const user = JSON.parse(process.env.VUE_APP_EMAIL).pt
        const password = JSON.parse(process.env.VUE_APP_PASSWORD).pt
        return 'Basic ' + window.btoa(user + ':' + password)
    },
    getStrings(callback) {
        if (window.appCache && window.appCache.strings) {
            return Utils.processResponse({
                request: {
                    response: JSON.stringify({
                        success: true,
                        data: window.appCache.strings
                    })
                }
            }, callback)
        }
        axios.get(axios.defaults.ptApiUrl + 'translations?website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getEnums(callback) {
        if (window.appCache && window.appCache.enums) {
            Utils.refreshEnums(window.appCache.enums)
            return callback()
        }
        axios.get(axios.defaults.ptApiUrl + 'enums?pt_id=' + window.ptId + '&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            let enums = {}
            if (response.data && response.data.data) {
                enums = response.data.data
            }
            Utils.refreshEnums(enums)
            callback()
        }).catch((response) => {
            Utils.refreshEnums({})
            callback()
        })
    },
    getConfig(callback) {
        axios.get(axios.defaults.ptApiUrl + 'feedback_config?db_id=' + window.ptId + '&website=1&lng=' + window.language + (window.initialQuiz ? '&initial_quiz=1' : '') + (window.configType ? ('&type=' + window.configType) : ''), {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getUser(data, callback) {
        if (window.appCache && window.appCache.user && window.appCache.user.id === data.id) {
            return Utils.processResponse({
                request: {
                    response: JSON.stringify({
                        success: true,
                        data: [window.appCache.user]
                    })
                }
            }, callback)
        }
        axios.get(axios.defaults.ptApiUrl + 'user?filter={"pt_id": ' + window.ptId + ',"id": ' + data.id + '}&photo=0&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization()
            }
        }).then((response) => {
            Utils.processResponse(response, callback);
        }).catch((response) => {
            Utils.processResponse(response, callback);
        });
    },
    getUserByField(data, callback) {
        axios.get(axios.defaults.ptApiUrl + 'user?search={"' + data.field + '":["' + data.value + '"],"pt_id":[' + window.ptId + ']}&photo=0&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization()
            }
        }).then((response) => {
            Utils.processResponse(response, callback);
        }).catch((response) => {
            Utils.processResponse(response, callback);
        });
    },
    getAlerts(data, callback) {
        axios.get(axios.defaults.ptApiUrl + 'alerts?pt_id=' + window.ptId + '&id=' + data.client_id + '&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getPhysicalEvaluation(data, callback) {
        axios.get(axios.defaults.ptApiUrl + 'physical_evaluation?db_id=' + data.client_id + '&' + (data.id ? ('filter={"id":' + data.id) + '}' : 'filter={"status":3}') + '&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getLastPhysicalEvaluation(data, callback) {
        axios.get(axios.defaults.ptApiUrl + 'physical_evaluation?db_id=' + data.client_id + '&fields=["id","changes"]&order={"id":1}&limit=1&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getTypePhysicalEvaluation(data, callback) {
        const today = moment().format('YYYY-MM-DD')
        axios.get(axios.defaults.ptApiUrl + 'physical_evaluation?db_id=' + data.client_id + '&filter={"type":' + window.configType + ',"date":"' + today + '"}&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    newPhysicalEvaluation(data, callback) {
        axios.post(axios.defaults.ptApiUrl + 'physical_evaluation?db_id=' + data.client_id + '&website=1' + (window.openedByDashboard ? '&dashboard=1' : '') + '&lng=' + window.language,
            data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization()
            }
        }).then((response) => {
            Utils.processResponse(response, callback);
        }).catch((response) => {
            Utils.processResponse(response, callback);
        });
    },
    editPhysicalEvaluation(data, callback) {
        const id = parseFloat(data.id)
        delete data.id

        axios.patch(axios.defaults.ptApiUrl + 'physical_evaluation?db_id=' + data.client_id + '&id=' + id + '&website=1&lng=' + window.language,
            data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    newPhysicalEvaluationPhotos(data, callback) {
        axios.post(axios.defaults.ptApiUrl + 'physical_eval_photo?db_id=' + data.client_id + '&website=1&lng=' + window.language,
            data.photos, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getPhysicalEvaluationPhotos(data, callback) {
        axios.get(axios.defaults.ptApiUrl + 'physical_eval_photo?db_id=' + data.client_id + '&filter={"pe_id":' + data.id + '}&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    deletePhysicalEvaluationPhotos(data, callback) {
        axios.delete(axios.defaults.ptApiUrl + 'physical_eval_photo?db_id=' + data.client_id + '&pe_id=' + data.pe_id + '&ids=' + JSON.stringify(data.ids) + '&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    updateUser(data, callback) {
        axios.patch(axios.defaults.ptApiUrl + 'user?id=' + window.clientId + '&pt_id=' + window.ptId + '&website=1&lng=' + window.language,
            data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getVideoName(data, callback) {
        axios.get(axios.defaults.ptApiUrl + 'phy_eval_video_name?pt_id=' + window.ptId + '&user_id=' + window.clientId + '&pe_id=' + (data.pe_id ? data.pe_id : 0) + '&field=' + data.field + '&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getRequest(data, callback) {
        if (data.url.indexOf('https://') === -1) {
            data.url = axios.defaults.ptApiUrl + data.url
        }
        axios.get(data.url, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            callback({
                success: true,
                data: response.data,
                item: data.item
            })
        }).catch((response) => {
            callback({
                success: false,
                data: [],
                item: data.item
            })
        })
    },
    sendAppNotification(data, callback) {
        axios.post(axios.defaults.ptApiUrl + 'notification/push?website=1&lng=' + window.language,
            data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getNutritionPlan(id, callback) {
        axios.get(axios.defaults.ptApiUrl + 'food_plan?db_id=' + id + '&filter={"status":1}&order={"id":1}&fields=["id","type"]&fast=1&limit=1&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getOldNutritionPlan(id, callback) {
        axios.get(axios.defaults.ptApiUrl + 'nutrition?db_id=' + id + '&filter={"status":0}&order={"id":1}&fields=["id","description"]&limit=1&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getTrainingPlan(id, callback) {
        axios.get(axios.defaults.ptApiUrl + 'training_plan?db_id=' + id + '&filter={"status":1}&order={"id":1}&fields=["id","days_count"]&fast=1&limit=1&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getWorkouts(callback) {
        axios.get(axios.defaults.ptApiUrl + 'workout?db_id=' + window.ptId  + '&query=[{"f":"flags","q":1,"v":0}]&fields=["id","flags"]&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    sendPayment(data, callback) {
        axios.post(axios.defaults.ptApiUrl + 'payment?db_id=' + data.id + '&website=1&lng=' + window.language,
            data, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getPaymentPack(data, callback) {
        axios.get(axios.defaults.ptApiUrl + 'pack?db_id=' + window.ptId + '&query=[{"f":"id","q":0,"v":' + data.id + ',"n":0}]' + (data && data.fields ? ('&fields=' + JSON.stringify(data.fields)) : '') + '&website=1&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
    getEmployees(data, callback) {
        axios.get(axios.defaults.ptApiUrl + 'user?search={"pt_id":[' + window.ptId + '],"id":' + JSON.stringify(data.ids) + '}&fields=["id","name","sub_type"]&photo=0&lng=' + window.language, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: this.getAuthorization(),
            },
        }).then((response) => {
            Utils.processResponse(response, callback)
        }).catch((response) => {
            Utils.processResponse(response, callback)
        })
    },
}
